import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { URLS } from 'src/app/constants/URLS';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.css']
})
export class QueueComponent implements OnInit {

  queue: any[] = [];
  userId: string = '';
  screenName:string = '';
  isLoading: boolean = false;
  mediaUrl: any = URLS.profileImageBaseUrl;
  env:string = environment.TQR_SERVICE;
  imgUrl:string = URLS.imgUrl;

  constructor(
    private myContentService: MycontentserviceService,
    private toastrService: CustomControlsService,
    private router: Router,
    private whitelabelService: WhiteLabelService
  ) { }

  ngOnInit(): void {
    this.userId = localStorage.getItem('userId');
    this.screenName = localStorage.getItem('screenName');
    this.getQueueList();
  }

  getQueueList() {
    this.isLoading = true;
    this.myContentService.getWatchListOfUser(this.userId).subscribe(result => {
      this.queue = [];
      result.forEach(movie => {
        this.myContentService.transformData(movie);
        if (movie.content_sub_type === '1') {
          this.queue.push(movie);
        }
      });
      this.isLoading = false;
      console.log('queue', this.queue);
    });
  }

  playAll(video:any) {
    const route = this.whitelabelService.getPrefixedRoute('watch');
    this.router.navigate([route], {
      queryParams: {
        ref: video.vidLibId,
        list: 'wl'
      }
    })
  }

  playVideo(video: any, index:number) {
    const route = this.whitelabelService.getPrefixedRoute('watch');
    this.router.navigate([route], {
      queryParams: {
        ref: video.vidLibId,
        list: 'wl',
        index: index
      }
    })
  }

  removeFromQueue(video: any, event: Event) {
    event.stopPropagation();
    this.myContentService.removeFromWatchList(this.userId, video.vidLibId).subscribe((result) => {
      this.queue = this.queue.filter(item => item.vidLibId !== video.vidLibId);
      this.showSuccess('Video removed from queue');
    }, (error) => {
      this.showError('Something went wrong');
    });
  }

  showSuccess(message: string): void {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }

  showError(message: string): void {
    this.toastrService.showNotification(
      'error',
      '',
      message,
      3000
    );
  }

  formatDuration(duration: any): string {
    if (!duration) return '0:00';
    if (typeof duration === 'string') {
      if (duration.includes(':')) {
        const parts = duration.split(':');
        if (parts.length === 3) {
          const hours = parseInt(parts[0]);
          const minutes = parseInt(parts[1]);
          const seconds = parts[2];
          const totalMinutes = hours * 60 + minutes;
          return `${totalMinutes}:${seconds}`;
        }
        return duration; 
      }
    }
    if (typeof duration === 'number') {
      const minutes = Math.floor(duration / 60);
      const seconds = duration % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
    return '0:00';
  }

  formatViews(views: number): string {
    if (views >= 1000000) {
      return (views / 1000000).toFixed(1) + 'M';
    } else if (views >= 1000) {
      return (views / 1000).toFixed(1) + 'K';
    }
    return views?.toString() || '0';
  }

  formatTimeAgo(date: string): string {
    if (!date) return '';
    const now = new Date();
    const videoDate = new Date(date);
    const diffTime = Math.abs(now.getTime() - videoDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return '1 day ago';
    if (diffDays < 30) return `${diffDays} days ago`;
    if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
    return `${Math.floor(diffDays / 365)} years ago`;
  }
}